//import * as d3 from 'd3';

export function style_outline_properties(feature){
  return {
    color: 'grey',
    opacity: 0.7,
    fillColor: 'white',
    fillOpacity: 0,
    weight: 0.6
  };
}

export function style_properties(feature){
  return {
    color: 'grey',
    opacity: 0.7,
    fillColor: 'white',
    fillOpacity: 0.3,
    weight: 0.6
  };
}

export function style_ditches(feature){
  return {
    color: '#1034A6',
    weight: 0.6,
    zIndex: 2
  };
}

export function style_old_roads(feature){
  return {
    color: '#FFD300',
    weight: 0.6,
    zIndex: 2
  };
}

export function style_water(feature){
  return {
    fillColor: '#00B2EE',
    color: '#00688B',
    weight: 0.6,
    zIndex: 2
  };
}

export function style_fuel_tanks(feature){
  return {
    fillColor: '#ffa500',
    color: "#cc8400",
    opacity: 0.8,
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_cade(feature){
  return {
    color: '#cc99a2',
    opacity: 0.8,
    fillColor: '#e5acb6',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_camps(feature){
  return {
    color: '#66b266',
    opacity: 0.7,
    fillColor: '#99cc99',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_dumps(feature){
  return {
    color: '#96572a',
    opacity: 0.8,
    fillColor: '#b98f71',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_pineapple_fields(feature){
  return {
    color: '#96572a',
    opacity: 0.8,
    fillColor: '#b98f71',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_pineapple_pesticides(feature){
  return {
    color: '#FF1493',
    opacity: 0.8,
    fillColor: '#FF69B4',
    fillOpacity: 0.8,
    weight: 0.6
  };
}


function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

var color;
export function style_fields(feature){
  color = getRandomColor();
  return {
    color: color,
    fillColor: color,
    fillOpacity: 0.6,
    weight: 0.6,
    zIndex: 452
  };
}

//var otherColors = chroma.scale(['#fafa6e','#2A4858']).mode('lch').colors(16)

export function style_other(feature){
  return {
    color: '#96572a',
    opacity: 0.8,
    fillColor: '#b98f71',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

//var seepRadii = d3.scaleLinear().domain([0,50,200,500,3000,57000]).range([3,4,5,6,7,8])


export let style_cesspools = {
  radius: 5,
  color: '#39ff14',
  opacity: 0.8,
  fillColor: '#39ff14',
  fillOpacity: 0.8,
  weight: 0.6
};

export let style_wells = {
  radius: 4,
  fillColor: '#62c896',
  color: "#A9A9A9",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_wells_dom = {
  radius: 4,
  fillColor: "#e75649",
  color: "#A9A9A9",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};


export let style_wells_mun = {
  radius: 4,
  fillColor: "#092e6e",
  color: "#A9A9A9",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_fuel_wells = {
  radius: 4,
  fillColor: '#ffa500',
  color: "#cc8400",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_cemeteries = {
  radius: 4,
  fillColor: '#a1ee33',
  color: "#42b97c",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_pumps = {
  radius: 4,
  fillColor: '#e50000',
  color: "#b20000",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_carve_outs = {
  fillColor: '#e50000',
  color: "#103A46",
  fillOpacity: 0,
  opacity: 0.8,
  weight: 1.2,
  zIndex: 15
};

export let style_mills = {
  fillColor: '#69656f',
  color: "#293249",
  fillOpacity: 0,
  opacity: 0.8,
  weight: 1.2,
  zIndex: 15
};

export let style_landfills = {
  fillColor: '#f6ae99',
  color: "#ff3860",
  fillOpacity: 0,
  opacity: 0.8,
  weight: 1.2,
  zIndex: 15
};

export let style_state_land = {
  fillColor: '#2E8B57',
  color: "#2E8B57",
  fillOpacity: 0.5,
  opacity: 0.9,
  weight: 1.2,
  zIndex: 15
};

export let style_endangered_species = {
  fillColor: '#008080',
  color: "#008080",
  fillOpacity: 0.5,
  opacity: 0.9,
  weight: 1.2,
  zIndex: 15
};

export let style_transformers = {
  fillColor: '#A52A2A',
  color: "#A52A2A",
  fillOpacity: 0.5,
  opacity: 0.9,
  weight: 1.2,
  zIndex: 15
};


export function onEveryFeatureProperties(feature, layer){
  if (feature.properties) {
      //layer.bindPopup('<b>TMK:</b> ' + feature.properties.tmk);
  }
}

export function onEveryFeatureFields(feature, layer){
  if (feature.properties.Name) {
    layer.bindPopup('<b>Field:</b> ' + feature.properties.Name)
  } else {
    layer.bindPopup('<b>Field:</b> No Field Name')
  }
}

export function onEveryFeatureFieldsLabels(feature, layer){
  if (feature.properties.Name) {
    layer.bindPopup('<b>Field:</b> ' + feature.properties.Name).bindTooltip(feature.properties.Name, { permanent: true, direction: 'auto', className: "my-label", offset: [0, 0] })
  } else {
    layer.bindPopup('<b>Field:</b> No Field Name')
  }
}

export function onEveryFeatureWells(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Well:</b> ' + feature.properties.WELL_NAME +
        '</br><b>Type:</b> ' + feature.properties.WELL_TYPE + 
        '</br><b>Use:</b> ' + feature.properties.well_use + 
        '</br><b>Depth:</b> ' + feature.properties.WELL_DEPTH
      );
  }
}

export function onEveryFeatureCesspools(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Note:</b> ' + (feature.properties.commercial ? feature.properties.commercial : 'N/A') +
        '</br><b>Source:</b> ' + feature.properties.source 
      );
  }
}

export function onEveryFeatureFuelWells(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Well:</b> ' + feature.properties.Name
      );
  }
}

export function onEveryFeatureWater(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Name:</b> ' + (feature.properties.gnis_name ? feature.properties.gnis_name : '') +
        '</br><b>Type:</b> ' + feature.properties.ftr_typ + 
        '</br><b>Description:</b> ' + feature.properties.dscrptn
      );
  }
}

export function onEveryFeatureRes(feature, layer){
  if (feature.properties) {
      layer.bindPopup(feature.properties.Name);
  }
}

export function onEveryFeatureFuelTanks(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Type:</b> ' + feature.properties.Type 
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/MapView/overlay_styles.js